import {ValidatorProvider} from '@dofleini/validator';
import {Form, Tooltip} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

import {CACHE_KEY_LIST_CAUSE} from '@/modules/configuration/contants/cause';
import CauseApiService from '@/modules/configuration/services/CauseApiService';
import SelectElementCmp from '@/utils/SelectElementCmp';

const CauseSelect = ({value, onChange, filters, ...props}) => {
  const {t} = useTranslation('common');
  const currentValue = value && typeof value === 'object' ? value._id : value;
  
  return (
    <>
      <div className='w-full'>
        <SelectElementCmp
          {...props}
          queryKey={CACHE_KEY_LIST_CAUSE}
          filters={filters}
          service={CauseApiService}
          includeValue={value}
          value={currentValue}
          placeholder={t('selectPlaceholder')}
          onChange={onChange}
          queryConfig={{refetchOnWindowFocus: false}}
          customItemRender={(item) => <>
            <Tooltip title={item.label || item.title}>{item.label || item.title}</Tooltip>
            {!!item.description && <span className={classNames('flex flex-row italic text-xs opacity-75')}>
              {item.description}
            </span>}
          </>}
        />
      </div>
    </>
  );
};

CauseSelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  filters: PropTypes.object
};

export default memo(CauseSelect);

export const renderCauseSelect = ({formItemProps, field, form}) => {
  
  const rules = field?.required && [{required: true, message: ValidatorProvider.t('validateMessages.required')}];
  
  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <CauseSelect {...field?.widgetProps} {...field} form={form}/>
    </Form.Item>
  );
};
